(function () {
  var PURPOSE_ORDER = ['refuge', 'compassion', 'clarity', 'abundance', 'healing', 'longevity', 'protection', 'purification', 'passage'];
  var QUESTIONS = [
    {
      id: 'for',
      question: 'Who is it for?',
      note: 'A piece kept and a piece given are rarely the same piece.',
      options: [
        { value: 'self', title: 'For myself', detail: 'Something to live alongside, for a long time.', weights: { refuge: 1, clarity: 1 } },
        { value: 'gift', title: 'For someone else', detail: 'To be handed over. Most of this tradition is.', weights: { compassion: 2, longevity: 1, healing: 1 } },
        { value: 'home', title: 'For a household', detail: 'A room, a doorway, a shelf that has been waiting.', weights: { protection: 2, abundance: 1, refuge: 1 } }
      ]
    },
    {
      id: 'ask',
      question: 'What is it meant to help with?',
      note: 'Answer for the thing itself. The occasion comes next.',
      options: [
        { value: 'ground', title: 'Starting out', detail: 'Ground to stand on, before anything else is asked.', weights: { refuge: 3, purification: 1, clarity: 1 } },
        { value: 'other', title: "Someone else's difficulty", detail: 'Carried on their behalf, not on your own.', weights: { compassion: 3, healing: 1, passage: 1 } },
        { value: 'clear', title: 'Thinking clearly', detail: 'Discernment, and the patience to use it.', weights: { clarity: 3, purification: 1 } },
        { value: 'work', title: 'Work, and a living from it', detail: 'Prosperity that comes of effort.', weights: { abundance: 3, longevity: 1 } },
        { value: 'guard', title: 'Keeping something safe', detail: 'Turned outward, facing the door.', weights: { protection: 3, refuge: 1 } },
        { value: 'release', title: 'Letting something go', detail: 'What has accumulated, cleared away.', weights: { purification: 3, passage: 2, healing: 1 } }
      ]
    },
    {
      id: 'season',
      question: 'And the season you are in?',
      note: 'A thangka is commissioned for a moment, not for a mood.',
      options: [
        { value: 'begin', title: 'Beginning something', detail: 'A first year, a first room, a first attempt.', weights: { refuge: 2, abundance: 2, purification: 1 } },
        { value: 'middle', title: 'In the middle of something hard', detail: 'Not finished, and not able to stop.', weights: { protection: 2, compassion: 2, healing: 1 } },
        { value: 'mend', title: 'Mending', detail: 'An illness, an exhaustion, someone caring for one.', weights: { healing: 3, longevity: 1 } },
        { value: 'study', title: 'Studying, or deciding', detail: 'An examination, a thesis, work that is thinking.', weights: { clarity: 3 } },
        { value: 'years', title: 'Counting years', detail: 'A sixtieth birthday, an anniversary, a long marriage.', weights: { longevity: 3, abundance: 1 } },
        { value: 'after', title: 'After a death', detail: 'The forty-nine days, or the anniversary of them.', weights: { passage: 4, compassion: 1 } }
      ]
    },
    {
      id: 'form',
      question: 'Where will it live?',
      note: 'Choose a form to explore. Availability varies by purpose.',
      options: [
        { value: 'wall', title: 'On a wall', detail: 'Hung in the open, where the room can see it.' },
        { value: 'worn', title: 'Against the body', detail: 'A pendant, a gau box, a ring or other jewellery.' },
        { value: 'carried', title: 'Carried, and closed', detail: 'Explore gau boxes, which can also be worn.' },
        { value: 'shelf', title: 'On a shelf', detail: 'A desk, a niche, a small household shrine.' }
      ]
    }
  ];
  var FORM_LABELS = { wall: 'On a wall', worn: 'Against the body', carried: 'Carried, and closed', shelf: 'On a shelf' };
  var FORM_BANDS = { wall: ['Painting'], worn: ['Pendant', 'Earrings', 'Ring', 'Bracelet', 'Gau box'], carried: ['Gau box'], shelf: ['Statue', 'Incense holder', 'Butter lamp', 'Ornament'] };
  var ROMAN = ['', 'I', 'II', 'III', 'IV'];

  function findOption(question, value) {
    return question.options.find(function (option) { return option.value === value; });
  }

  function initialise(root) {
    if (!root || root.dataset.finderInitialised === 'true') return;
    root.dataset.finderInitialised = 'true';

    var configNode = root.querySelector('[data-finder-config]');
    var questionsHost = root.querySelector('[data-finder-questions]');
    var result = root.querySelector('[data-finder-result]');
    if (!configNode || !questionsHost || !result) return;

    var config;
    try { config = JSON.parse(configNode.textContent); } catch (error) { return; }

    var purposes = {};
    (config.purposes || []).forEach(function (purpose) {
      if (PURPOSE_ORDER.indexOf(purpose.id) !== -1 && !purposes[purpose.id]) purposes[purpose.id] = purpose;
    });

    var answers = [];
    var recordsNode = root.querySelector('[data-finder-records]');
    var groupsNode = root.querySelector('[data-finder-groups]');
    var records = recordsNode ? JSON.parse(recordsNode.textContent) : [];
    var groups = groupsNode ? JSON.parse(groupsNode.textContent) : [];
    var purposeCounts = {};
    Object.values(purposes).forEach(function (purpose) {
      purposeCounts[purpose.id] = purpose.collectionCount || 0;
    });
    groups.forEach(function (group) {
      purposeCounts[group.id] = records.filter(function (record) { return group.figures.includes(record.facet); }).length;
    });
    var current = 0;
    var catalogueRequest;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function answerUrl(writeAnswers) {
      var url = new URL(window.location.href);
      if (writeAnswers) url.searchParams.set('a', answers.map(function (answer) { return answer.value; }).join(','));
      else url.searchParams.delete('a');
      window.history.replaceState(null, '', url.pathname + url.search + url.hash);
    }

    function restoreAnswers() {
      var value = new URL(window.location.href).searchParams.get('a');
      if (!value) return false;
      var tokens = value.split(',');
      if (tokens.length !== QUESTIONS.length) return false;
      var restored = QUESTIONS.map(function (question, index) { return findOption(question, tokens[index]); });
      if (restored.some(function (answer) { return !answer; })) return false;
      answers = restored;
      return true;
    }

    function focusHeading(selector) {
      var heading = root.querySelector(selector);
      if (heading) heading.focus({ preventScroll: true });
    }

    function renderQuestion() {
      var question = QUESTIONS[current];
      var selected = answers[current];
      questionsHost.replaceChildren();

      var wrapper = document.createElement('div');
      wrapper.className = 'himalayan-finder__question qwrap';
      var progress = document.createElement('div');
      progress.className = 'himalayan-finder__progress qbar';
      var step = document.createElement('p');
      step.className = 'himalayan-finder__step qstep';
      step.textContent = ROMAN[current + 1] + ' of ' + ROMAN[QUESTIONS.length];
      var ticks = document.createElement('span');
      ticks.className = 'himalayan-finder__ticks qticks';
      ticks.setAttribute('aria-hidden', 'true');
      QUESTIONS.forEach(function (_, index) {
        var tick = document.createElement('i');
        tick.className = 'himalayan-finder__tick';
        if (index <= current) tick.classList.add('is-on');
        ticks.appendChild(tick);
      });
      progress.append(step, ticks);

      var title = document.createElement('h2');
      title.id = 'FinderQuestion-' + root.dataset.sectionId;
      title.className = 'himalayan-finder__question-title qq';
      title.tabIndex = -1;
      title.textContent = question.question;
      var note = document.createElement('p');
      note.className = 'himalayan-finder__question-note qnote';
      note.textContent = question.note;

      var options = document.createElement('div');
      options.className = 'himalayan-finder__options qopts' + (question.options.length % 3 === 0 ? ' qopts--three' : '');
      options.setAttribute('role', 'group');
      options.setAttribute('aria-labelledby', title.id);
      question.options.forEach(function (option, index) {
        var button = document.createElement('button');
        button.className = 'himalayan-finder__option qopt';
        button.type = 'button';
        button.style.setProperty('--i', index);
        button.dataset.value = option.value;
        button.setAttribute('aria-pressed', selected && selected.value === option.value ? 'true' : 'false');
        var optionTitle = document.createElement('b');
        optionTitle.textContent = option.title;
        var detail = document.createElement('span');
        detail.textContent = option.detail;
        button.append(optionTitle, detail);
        button.addEventListener('click', function () {
          if (questionsHost.dataset.transitioning) return;
          questionsHost.dataset.transitioning = 'true';
          answers[current] = option;
          options.querySelectorAll('button').forEach(function (item) {
            item.setAttribute('aria-pressed', item === button ? 'true' : 'false');
          });
          window.setTimeout(function () {
            delete questionsHost.dataset.transitioning;
            if (current < QUESTIONS.length - 1) {
              current += 1;
              renderQuestion();
              focusHeading('.himalayan-finder__question-title');
            } else renderResult(true);
          }, reduceMotion ? 0 : 180);
        });
        options.appendChild(button);
      });

      var footer = document.createElement('div');
      footer.className = 'himalayan-finder__question-footer qfoot';
      if (current > 0) {
        var back = document.createElement('button');
        back.className = 'himalayan-finder__back qback';
        back.type = 'button';
        back.textContent = '← Back';
        back.addEventListener('click', function () {
          if (questionsHost.dataset.transitioning) return;
          current -= 1;
          renderQuestion();
          focusHeading('.himalayan-finder__question-title');
        });
        footer.appendChild(back);
      }
      var card = document.createElement('div');
      card.className = 'qcard is-himalayan-finder-dealing';
      card.append(title, note, options, footer);
      wrapper.append(progress, card);
      questionsHost.appendChild(wrapper);
    }

    function winner(position) {
      var scores = {};
      PURPOSE_ORDER.forEach(function (id) { scores[id] = 0; });
      answers.slice(0, 3).forEach(function (answer) {
        Object.keys(answer.weights || {}).forEach(function (id) { scores[id] += answer.weights[id]; });
      });
      return PURPOSE_ORDER.slice().sort(function (left, right) {
        return scores[right] - scores[left] || (purposeCounts[right] || 0) - (purposeCounts[left] || 0) || PURPOSE_ORDER.indexOf(left) - PURPOSE_ORDER.indexOf(right);
      })[position || 0];
    }

    function setField(selector, value) {
      var field = root.querySelector(selector);
      if (!field) return;
      field.value = value;
      field.setAttribute('value', value);
    }

    async function nativeCount(source, signal) {
      var url = new URL(source, location.origin);
      if (url.origin !== location.origin || !/\/collections\/[^/]+$/.test(url.pathname)) throw new Error('Invalid catalogue URL');
      url.searchParams.set('section_id', 'himalayan-filter-count');
      var response = await fetch(url, { signal: AbortSignal.any([signal, AbortSignal.timeout(15000)]) });
      if (!response.ok) throw new Error('Catalogue count failed');
      var doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      var node = doc.querySelector('[data-native-filter-result]');
      if (!node) throw new Error('Missing native filter response');
      var data = JSON.parse(node.textContent);
      if (!Number.isSafeInteger(data.count) || data.count < 0 || !Array.isArray(data.active)) throw new Error('Invalid count');
      // An unavailable filter must never broaden a recommendation to unrelated works.
      if (data.count > 0) url.searchParams.forEach(function (value, key) {
        if (key.startsWith('filter.') && !data.active.some(function (f) { return f.name === key && String(f.value) === value; })) throw new Error('Filter was not applied');
      });
      return data.count;
    }

    async function updateNativeCatalogue(purpose, form, formLabel, signal) {
      var tally = root.querySelector('[data-finder-tally]');
      var types = { wall: ['Thangka Painting'], worn: ['Pendant', 'Earrings', 'Ring', 'Bracelet', 'Gau Box'], carried: ['Gau Box'], shelf: ['Statue', 'Incense Holder', 'Electric Butter Lamp', 'Ornament'] };
      var url = new URL(purpose.collectionUrl, location.origin);
      types[form].forEach(function (type) { url.searchParams.append('filter.p.product_type', type); });
      try {
        var counts = await Promise.all([nativeCount(url, signal), nativeCount(purpose.collectionUrl, signal)]);
        var count = counts[0], total = counts[1];
        if (signal.aborted || result.hidden) return;
        root.querySelector('[data-finder-catalogue-all]').href = purpose.collectionUrl;
        var link = root.querySelector('[data-finder-catalogue-link]');
        link.href = count ? url.pathname + url.search : purpose.collectionUrl;
        link.textContent = count ? tally.dataset.seeLabel : tally.dataset.widenLabel;
        root.querySelector('[data-finder-tally-count]').textContent = count || tally.dataset.emptyLabel;
        root.querySelector('[data-finder-tally-unit]').textContent = count === 1 ? tally.dataset.singleLabel : count ? tally.dataset.countLabel : '';
        root.querySelector('[data-finder-tally-condition]').textContent = tally.dataset.conditionLabel.replace('[purpose]', purpose.title.toLowerCase()).replace('[form]', formLabel.toLowerCase());
        root.querySelector('[data-finder-tally-total]').textContent = tally.dataset.totalLabel.replace('[count]', total);
        var mark = root.querySelector('[data-finder-tally-image]');
        if (purpose.mark) { mark.src = purpose.mark; mark.hidden = false; }
        tally.classList.toggle('tally--none', !count);
        tally.hidden = false;
      } catch (error) {
        if (!signal.aborted) tally.hidden = true;
      }
    }

    async function renderResult(shouldScroll) {
      if (!config.referencePreview) {
        catalogueRequest?.abort();
        catalogueRequest = new AbortController();
        var countSignal = catalogueRequest.signal;
        await Promise.all(Object.values(purposes).map(async function (p) {
          try { purposeCounts[p.id] = await nativeCount(p.collectionUrl, countSignal); }
          catch (error) { purposeCounts[p.id] = 0; }
        }));
        if (countSignal.aborted) return;
      }
      var purposeId = winner();
      var purpose = purposes[purposeId] || { id: purposeId, number: '', title: purposeId, titleZh: '', line: '', aura: '', url: null };
      var formLabel = FORM_LABELS[answers[3].value];
      root.style.setProperty('--himalayan-finder-aura', purpose.aura || '#b0803a');
      root.querySelector('[data-finder-purpose-number]').textContent = 'Purpose ' + purpose.number + ' of nine';
      root.querySelector('[data-finder-purpose-title]').textContent = purpose.title;
      root.querySelector('[data-finder-purpose-zh]').textContent = purpose.titleZh || '';
      root.querySelector('[data-finder-purpose-line]').textContent = purpose.line || '';
      root.querySelector('[data-finder-purpose-lead]').textContent = purpose.lead || '';
      root.querySelector('[data-finder-brief-purpose]').textContent = purpose.title;
      root.querySelector('[data-finder-brief-answers]').textContent = ' · ' + answers.map(function (answer) { return answer.title.toLowerCase(); }).join(' · ');
      root.querySelector('[data-finder-brief-form]').textContent = formLabel.toLowerCase();

      var recap = root.querySelector('[data-finder-recap]');
      recap.replaceChildren();
      answers.forEach(function (answer, index) {
        var item = document.createElement('li');
        var label = document.createElement('span');
        var questionLabel = QUESTIONS[index].question.replace(/^And /, '').replace(/\?$/, '');
        label.textContent = questionLabel.charAt(0).toUpperCase() + questionLabel.slice(1) + ': ';
        var value = document.createElement('b');
        value.textContent = answer.title;
        item.append(label, value);
        recap.appendChild(item);
      });

      var purposeLink = root.querySelector('[data-finder-purpose-link]');
      purposeLink.hidden = !purpose.url;
      if (purpose.url) purposeLink.href = purpose.url;
      else purposeLink.removeAttribute('href');
      purposeLink.textContent = config.resultLinkLabel;

      var tally = root.querySelector('[data-finder-tally]');
      catalogueRequest?.abort();
      if (tally) tally.hidden = true;
      var previousAlternative = root.querySelector('[data-finder-alternative]');
      if (previousAlternative) previousAlternative.hidden = true;
      if (tally && config.referencePreview && config.catalogueUrl) {
        var group = groups.find(function (item) { return item.id === purposeId; });
        var bands = FORM_BANDS[answers[3].value];
        var all = records.filter(function (record) { return group.figures.includes(record.facet); });
        var count = all.filter(function (record) { return bands.includes(record.band); }).length;
        var catalogue = new URL(config.catalogueUrl, location.origin);
        catalogue.searchParams.set('purpose', purposeId);
        root.querySelector('[data-finder-catalogue-all]').href = catalogue.pathname + catalogue.search;
        if (count) catalogue.searchParams.set('band', bands.join('|'));
        var catalogueLink = root.querySelector('[data-finder-catalogue-link]');
        catalogueLink.href = catalogue.pathname + catalogue.search;
        catalogueLink.textContent = count ? tally.dataset.seeLabel : tally.dataset.widenLabel;
        root.querySelector('[data-finder-tally-count]').textContent = count || tally.dataset.emptyLabel;
        root.querySelector('[data-finder-tally-unit]').textContent = count === 1 ? tally.dataset.singleLabel : count ? tally.dataset.countLabel : '';
        var mark = root.querySelector('[data-finder-tally-image]');
        if (purpose.mark) {
          mark.src = purpose.mark;
          mark.hidden = false;
        }
        root.querySelector('[data-finder-tally-condition]').textContent = tally.dataset.conditionLabel.replace('[purpose]', purpose.title.toLowerCase()).replace('[form]', formLabel.toLowerCase());
        root.querySelector('[data-finder-tally-total]').textContent = tally.dataset.totalLabel.replace('[count]', all.length);
        tally.classList.toggle('tally--none', !count);
        tally.hidden = false;
        var alternative = root.querySelector('[data-finder-alternative]');
        var runnerId = winner(1);
        var runner = purposes[runnerId];
        var runnerGroup = groups.find(function (item) { return item.id === runnerId; });
        if (runner?.url && runnerGroup) {
          var runnerLink = document.createElement('a');
          runnerLink.href = runner.url;
          runnerLink.textContent = runner.title;
          var allLink = document.createElement('a');
          allLink.href = root.querySelector('[data-finder-catalogue-all]').href;
          allLink.textContent = alternative.dataset.allLabel.replace('[count]', all.length).replace('[purpose]', purpose.title.toLowerCase());
          var copy = root.querySelector('[data-finder-alternative-copy]');
          copy.replaceChildren();
          alternative.dataset.summary.split(/(\[runner\]|\[description\]|\[all\])/).forEach(function (part) {
            copy.append(part === '[runner]' ? runnerLink : part === '[all]' ? allLink : document.createTextNode(part === '[description]' ? runnerGroup.sub.toLowerCase() : part));
          });
          alternative.hidden = false;
        }
      }
      if (tally && !config.referencePreview && purpose.collectionUrl) {
        catalogueRequest = new AbortController();
        updateNativeCatalogue(purpose, answers[3].value, formLabel, catalogueRequest.signal);
      }

      answerUrl(true);
      var answerSummary = answers.map(function (answer, index) { return QUESTIONS[index].question + ' ' + answer.title; }).join(' | ');
      setField('[data-finder-contact-purpose]', purpose.title);
      setField('[data-finder-contact-answers]', answerSummary);
      setField('[data-finder-contact-form]', formLabel);
      setField('[data-finder-contact-url]', window.location.href);

      questionsHost.hidden = true;
      result.hidden = false;
      window.requestAnimationFrame(function () {
        result.scrollIntoView({ behavior: shouldScroll && !reduceMotion ? 'smooth' : 'instant', block: 'start' });
      });
      focusHeading('[data-finder-purpose-title]');
    }

    root.querySelector('[data-finder-reset]').addEventListener('click', function () {
      catalogueRequest?.abort();
      answers = [];
      current = 0;
      answerUrl(false);
      result.hidden = true;
      questionsHost.hidden = false;
      renderQuestion();
      root.querySelector('himalayan-finder-gate')?.open(true);
      focusHeading('.himalayan-finder__question-title');
    });

    if (restoreAnswers()) renderResult(false);
    else {
      answerUrl(false);
      renderQuestion();
    }

    var success = root.querySelector('[data-finder-form-success]');
    if (success) success.focus({ preventScroll: true });
  }

  function initialiseAll(container) {
    if (container.matches && container.matches('[data-himalayan-finder]')) initialise(container);
    container.querySelectorAll('[data-himalayan-finder]').forEach(initialise);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initialiseAll(document); });
  else initialiseAll(document);
  document.addEventListener('shopify:section:load', function (event) { initialiseAll(event.target); });
})();
